import { Box, Button, styled } from "@mui/material";

export const ComparisonTableRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
});

export const TableToolbar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(1),
  flexShrink: 0,
}));

export const AgGridContainer = styled(Box)({
  height: "clamp(400px, 60vh, 700px)",
  ".fullscreen &": {
    flex: 1,
    minHeight: 0,
    height: "auto",
  },
  ".ag-floating-bottom-viewport": {
    overflowY: "hidden",
  },
});

export const ToolbarButton = styled(Button)({
  fontSize: "0.7rem",
});
